import { LoadStatus } from '@servicetitan/cp-ui';
import { CheckboxFieldState, InputFieldState } from '@servicetitan/form-state';
import { inject, injectable } from '@servicetitan/react-ioc';
import { FormState } from 'formstate';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { emailFieldValidator, requiredEmailFieldValidator } from '../utils/email.validator';
import { requiredPasswordFieldValidator } from '../utils/password.validator';
import { LoginResult, PortalAuthStore } from './portal-auth.store';

@injectable()
export class AuthLoginStore {
    @observable submitStatus = LoadStatus.None;
    @observable submitResult?: LoginResult;

    @computed get canSubmit() {
        return !this.form.$.email.hasError;
    }

    form = new FormState({
        email: new InputFieldState('')
            .validators(requiredEmailFieldValidator, emailFieldValidator)
            .disableAutoValidation(),
        password: new InputFieldState('')
            .validators(requiredPasswordFieldValidator)
            .disableAutoValidation(),
        keepSigned: new CheckboxFieldState(true),
    });

    private isInviteFlow = false;

    constructor(@inject(PortalAuthStore) private authStore: PortalAuthStore) {
        makeObservable(this);
    }

    init = (code?: string) => {
        this.isInviteFlow = !!code;
    };

    submit = async () => {
        await this.form.validate();

        if (!this.canSubmit) {
            return;
        }

        const { email, keepSigned, password } = this.form.$;

        runInAction(() => (this.submitStatus = LoadStatus.Loading));

        const loginResult = await this.authStore.login(
            email.value,
            password.value,
            keepSigned.value
        );

        runInAction(() => {
            this.submitStatus =
                !loginResult || (loginResult === LoginResult.Restricted && this.isInviteFlow)
                    ? LoadStatus.Ok
                    : LoadStatus.Error;
            this.submitResult = loginResult;

            if (loginResult === LoginResult.Invalid) {
                this.form.$.password.setError('Incorrect password');
                this.form.$.password.enableAutoValidation();
            }
        });
    };
}
